/// <amd-module name="Mention/MarkdownWithAutocomplete/Components/MarkdownTextFieldWithAutocomplete" />
import * as React from "react";
import { IMarkdownTextFieldProps, MarkdownTextField } from "VSS/Features/MarkdownEditor/Components";
import { IMarkdownFormattingArgs, IMarkdownFormattingResult, IMarkdownTextSource } from "VSS/Features/MarkdownEditor/Formatting/Contracts";
import { WrappedComponent } from "VSS/Platform/Layout";

export class MarkdownTextFieldWithAutocomplete extends React.Component<IMarkdownTextFieldProps> implements IMarkdownTextSource {
    private inputElement: React.RefObject<HTMLInputElement & HTMLTextAreaElement>;
    private markdownTextField = React.createRef<MarkdownTextField>();

    public constructor(props: IMarkdownTextFieldProps) {
        super(props);

        this.inputElement = this.props.inputElement || React.createRef<HTMLInputElement & HTMLTextAreaElement>();
    }

    public render(): JSX.Element {
        return (
            <>
                <MarkdownTextField {...this.props} inputElement={this.inputElement} ref={this.markdownTextField} />
                <WrappedComponent
                    wrappedType={"autocomplete-component"}
                    wrappedProps={{ inputElement: this.inputElement, onInputChange: this.props.onChange }}
                    dependencies={["ms.vss-mention.mention-autocomplete"]}
                />
            </>
        );
    }

    public applyFormatting(formattingResult: IMarkdownFormattingResult): void {
        if (this.markdownTextField.current) {
            this.markdownTextField.current.applyFormatting(formattingResult);
        }
    }

    public getInputElement(): (HTMLInputElement & HTMLTextAreaElement) | null {
        return this.inputElement.current;
    }

    public getFormattingArgs(): void | IMarkdownFormattingArgs {
        if (this.markdownTextField.current) {
            return this.markdownTextField.current.getFormattingArgs();
        }
    }

    public showError(error: Error): void {
        if (this.markdownTextField.current) {
            this.markdownTextField.current.showError(error);
        }
    }
}
